import React, { useState, useEffect } from 'react';
import { useNotification } from '../../../context/NotificationContext';
import client from '../../../services/graphqlClient';
import './ModalCrearActividad.css';

const ModalCrearActividad = ({
  show,
  onClose,
  proyectoId,
  capitulo,
  proveedores,
  actividadEditando,
  onActividadGuardada
}) => {
  const { success, error } = useNotification();
  const [formData, setFormData] = useState({
    descripcion: '',
    valor: ''
  });
  const [errores, setErrores] = useState({});
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (actividadEditando) {
      setFormData({
        descripcion: actividadEditando.descripcion || '',
        valor: actividadEditando.valor || actividadEditando.costo_presupuestado || ''
      });
    } else {
      setFormData({
        descripcion: '',
        valor: ''
      });
    }
  }, [actividadEditando, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    if (errores[name]) {
      setErrores(prev => ({ ...prev, [name]: null }));
    }
  };

  const validarFormulario = () => {
    const nuevosErrores = {};

    if (!formData.descripcion.trim()) {
      nuevosErrores.descripcion = 'La descripción es requerida';
    }

    setErrores(nuevosErrores);
    return Object.keys(nuevosErrores).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validarFormulario()) {
      return;
    }

    setGuardando(true);

    try {
      const dataToSend = {
        descripcion: formData.descripcion,
        valor: parseFloat(formData.valor) || 0,
        proyecto_id: proyectoId,
        capitulo_id: capitulo.id,
        fecha_realizacion: new Date().toISOString().split('T')[0],
        estado: 'planificado'
      };

      let data;
      if (actividadEditando) {
        const r = await client.mutate(`mutation($id: Int!, $input: ActualizarActividadInput!) { actualizarActividad(id: $id, input: $input) { success message } }`, {
          id: actividadEditando.id, input: { descripcion: dataToSend.descripcion, unidad: dataToSend.unidad, cantidad: dataToSend.cantidad, valor: dataToSend.valor }
        });
        data = r.actualizarActividad;
      } else {
        const r = await client.mutate(`mutation($input: CrearActividadInput!) { crearActividad(input: $input) { success message } }`, {
          input: { capitulo_id: dataToSend.capitulo_id, descripcion: dataToSend.descripcion, unidad: dataToSend.unidad, cantidad: dataToSend.cantidad, valor: dataToSend.valor }
        });
        data = r.crearActividad;
      }

      if (data.success) {
        success(`Actividad ${actividadEditando ? 'actualizada' : 'creada'} exitosamente`);
        onActividadGuardada(data.actividad);
        handleClose();
      } else {
        error('Error: ' + data.message);
      }
    } catch (err) {
      console.error('Error al guardar actividad:', err);
      error('Error al guardar la actividad');
    } finally {
      setGuardando(false);
    }
  };

  const handleClose = () => {
    setFormData({
      descripcion: '',
      valor: ''
    });
    setErrores({});
    onClose();
  };

  const formatMoney = (valor) => {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0
    }).format(valor || 0);
  };

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content modal-crear-actividad modal-simple" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{actividadEditando ? '✏️ Editar Actividad' : '➕ Nueva Actividad'}</h2>
          <button className="modal-close" onClick={handleClose}>×</button>
        </div>

        <div className="modal-subheader">
          <p>📋 Capítulo {capitulo.numero}: {capitulo.nombre}</p>
        </div>

        <form onSubmit={handleSubmit} className="actividad-form simple">
          <div className="form-group full-width">
            <label>Descripción de la Actividad *</label>
            <textarea
              name="descripcion"
              value={formData.descripcion}
              onChange={handleChange}
              placeholder="Describe la actividad..."
              rows="3"
              className={errores.descripcion ? 'error' : ''}
            />
            {errores.descripcion && (
              <span className="error-message">{errores.descripcion}</span>
            )}
          </div>

          <div className="form-group">
            <label>Presupuesto (Valor)</label>
            <input
              type="number"
              name="valor"
              value={formData.valor}
              onChange={handleChange}
              placeholder="0"
              step="100"
              min="0"
            />
            {formData.valor && (
              <span className="valor-preview">{formatMoney(formData.valor)}</span>
            )}
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-cancelar" onClick={handleClose}>
              Cancelar
            </button>
            <button type="submit" className="btn-guardar" disabled={guardando}>
              {guardando ? 'Guardando...' : (actividadEditando ? '💾 Actualizar' : '💾 Guardar')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalCrearActividad;
